import React from "react";
import { Navigate } from "react-router-dom";
import { LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Routes } from "constants/routes";

interface Props {
    children: React.ReactNode;
}

const PublicRoute: React.FC<Props> = ({ children }) => {
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

    if (token) {
        return <Navigate to={Routes.General} replace />;
    }

    return children;
};

export default PublicRoute;
